function Album() {
  return (
    <div>
      <h2 className="titulos">ACOMODAÇÕES</h2>
      <div className="album py-sm-0 bg-light">
        <div className="container-fluid mb-2">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_01.png"
                  alt="quarto1"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_02.png"
                  alt="quarto 2"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_03.png"
                  alt="quarto 3"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>

            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_04.png"
                  alt="quarto 4"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_05.png"
                  alt="quarto 5"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_06.png"
                  alt="quaro 6"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>

            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_07.png"
                  alt="quarto 7"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_08.png"
                  alt="quarto 8"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/quarto_09.png"
                  alt="quarto 9"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                />
              </div>
            </div>
          </div>
          
            <a
              href="https://wa.me/5511974751884?text=Olá,%20gostaria%20de%20mais%20
              informações%20sobre%20hospedagem."
              target="blank"
              className="icons-contact"
            >
              <img
                src="./img/whatsapp.png"
                alt="icone WhatsApp"
                className="whatsapp-link"
              />
            </a>
          
        </div>
      </div>
    </div>
  );
}
export default Album;
